<div class="d-flex overflow-hidden h-100 mh-100" #tableHost>
	<p-table
		class="w-100 h-100 mh-100"
		styleClass="h-100 d-flex flex-column justify-content-between"
		[value]="historyRows"
		[paginator]="true"
		[rows]="rows"
		[loading]="loading"
		[totalRecords]="totalRecords"
		[lazy]="true"
		(onLazyLoad)="loadOrderHistoricalDetails($event)"
	>
		<ng-template pTemplate="header">
			<tr>
				<th class="text-nowrap">Created</th>
				<th class="text-nowrap">Source</th>
				<th class="text-nowrap">Updated By</th>
				<th class="text-nowrap">Heading</th>
				<th class="text-nowrap">Comment Type</th>
				<th class="text-nowrap">Comment</th>
				<th class="text-nowrap">Visible to Vendor</th>
				<th class="text-nowrap">Visible to Client</th>
				<th class="text-nowrap">Action Required</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-row>
			<tr>
				<td class="text-break">{{ row.created | date: 'M/d/yyyy h:mm a' }}</td>
				<td class="text-break">{{ row.source }}</td>
				<td class="text-break">{{ row.updatedByName }}</td>
				<td class="text-break">{{ row.heading }}</td>
				<td class="text-break">{{ row.commentType }}</td>
				<td class="text-break">{{ row.comment }}</td>
				<td class="text-break">{{ row.visibleToVendor ? 'Yes' : 'No' }}</td>
				<td class="text-break">{{ row.visibleToClient ? 'Yes' : 'No' }}</td>
				<td class="text-break">{{ row.actionRequired ? 'Yes' : 'No' }}</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="9">No history found.</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="summary">
			<div *ngIf="historyRows.length > 0">
				Showing {{ historyRows.length }} notifications of {{ totalRecords }}.
			</div>
		</ng-template>
	</p-table>
</div>
<p-toast></p-toast>
